import * as actions from './qua-carriage.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiQuaMethod } from 'src/app/api/api-methods.qua';
import { Injectable, inject } from '@angular/core';
import { QuaCarriageI } from 'src/app/api/qua-carriage/qua-carriage.result.int';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingQuaCarriage } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class QuaCarriageEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiQuaMethod.quaCarriage, action.query))
            .pipe(
                map((result: QuaCarriageI) => actions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            messageText: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingQuaCarriage
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingQuaCarriage
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingQuaCarriage
            }),
        ]))
    );

}
